import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function LoginAudit() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("all");

  useEffect(() => {
    const params = { limit: 300 };
    if (status !== "all") params.success = status === "success";
    api.get("/security/login-audit", { params }).then(({ data }) => setItems(data));
  }, [status]);

  const visible = items.filter((i) => {
    if (!filter) return true;
    const f = filter.toLowerCase();
    return (i.email || "").toLowerCase().includes(f) || (i.ip || "").includes(f);
  });

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="login-audit-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Login audit</h1>
        <p className="text-muted-foreground">Every login attempt — successful or failed — across your organization.</p>
      </div>
      <div className="flex gap-3">
        <Input placeholder="Filter by email or IP…" value={filter} onChange={(e) => setFilter(e.target.value)} className="max-w-md" data-testid="login-filter" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-40" data-testid="login-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="success">Success</SelectItem>
            <SelectItem value="failure">Failed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Result</TableHead>
              <TableHead>MFA</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>User agent</TableHead>
              <TableHead>Reason</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visible.map((i) => (
              <TableRow key={i.id} data-testid={`login-row-${i.id}`}>
                <TableCell className="font-mono text-xs">{new Date(i.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-sm">{i.email}</TableCell>
                <TableCell>{i.success ? <Badge>OK</Badge> : <Badge variant="destructive">FAIL</Badge>}</TableCell>
                <TableCell>{i.mfa_used ? <Badge>MFA</Badge> : <span className="text-muted-foreground">—</span>}</TableCell>
                <TableCell className="font-mono text-xs">{i.ip || "—"}</TableCell>
                <TableCell className="text-xs max-w-[260px] truncate" title={i.user_agent}>{i.user_agent || "—"}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{i.failure_reason || "—"}</TableCell>
              </TableRow>
            ))}
            {visible.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">No login events.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
